// components
import Logo from '../components/Logo';

/* ============================================================================
   Layout "so logo" - usado por 404, 500, /maintenance e /auth/verify.

   Era um `styled('header')` do MUI cujo unico trabalho era posicionar o logo no
   canto superior esquerdo com padding diferente no celular e no desktop. Virou
   duas classes do Tailwind, sem tema.

   O `header` continua ABSOLUTO de proposito: as paginas que usam este layout
   centralizam o proprio conteudo na altura total da janela, e um header no fluxo
   normal empurraria esse conteudo para baixo do centro.
   ============================================================================ */

export default function LogoOnlyLayout({ children }) {
  return (
    <>
      <header className="absolute left-0 top-0 z-10 w-full p-6 pb-0 leading-none sm:p-10 sm:pb-0">
        <Logo />
      </header>
      {children}
    </>
  );
}
